import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';

export default function BreedLocationInfoSkeleton() {
  return (
    <div className="BreedLocationInfoSkeleton bg-gray-100">
      <div className="container-xxl">
        <div className="row pv12 pv16-md">
          <div className="col-12 col-md-6">
            <SkeletonBlock
              className="font-24 md:font-32 mb6 mb5-md"
              height="1em"
              width="8em"
            />
            <div className="tc tl-l">
              <SkeletonBlock className="dib" width="290px" height="217px" />
            </div>
          </div>
          <div className="col-12 col-md-6 self-center">
            <ul className="grid gap-8 md:font-20 mt6 mt0-md ph6-xl">
              {makeSequence(6).map(index => (
                <SkeletonBlock
                  key={index}
                  className="font-16 md:font-20"
                  height="1em"
                  width={index === 5 ? '50%' : '100%'}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
